import Echo from "laravel-echo";

import Pusher from "pusher-js";
window.Pusher = Pusher;

import {
  USER_ID,
  LOAD_ECHO,
  REVERB_APP_KEY,
  REVERB_HOST,
  REVERB_PORT,
  REVERB_SCHEME,
} from "./constants";

if (USER_ID && LOAD_ECHO) {
  window.Echo = new Echo({
    broadcaster: "reverb",
    key: REVERB_APP_KEY,
    wsHost: REVERB_HOST,
    wsPort: REVERB_PORT ?? 80,
    wssPort: REVERB_PORT ?? 443,
    forceTLS: (REVERB_SCHEME ?? "https") === "https",
    enabledTransports: ["ws", "wss"],
  });
}
